import { useState } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { PwaUpdateBanner } from "@cliqsuite/ui";

/** Guest updates remain user-controlled so an in-memory cart is preserved. */
export function UpdateBanner() {
  const [registration, setRegistration] = useState<ServiceWorkerRegistration | null>(null);
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({ onRegisteredSW: (_url, value) => setRegistration(value ?? null) });

  return (
    <PwaUpdateBanner
      needRefresh={needRefresh}
      setNeedRefresh={setNeedRefresh}
      updateServiceWorker={updateServiceWorker}
      registration={registration}
      message="A new version is ready. Update after finishing your order."
      allowDismiss={false}
    />
  );
}
